module.exports = __webpack_public_path__ + "static/img/bean_500.6732d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/img/bean_500.png
// module id = ayRN
// module chunks = 1